export class CannotAccessFirstQuestionError extends Error {
}
